import React, { useState } from 'react';
import styled from 'styled-components';
import { FormField, Button } from './FormElements';

const FormContainer = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.text};
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
  margin: 0 0 2rem;
`;

const WelcomeScreen = ({ formData, updateFormData, nextStep }) => {
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\(\d{2}\)\d{5}-\d{4}$/;
    return phoneRegex.test(phone);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.nome_responsavel) {
      newErrors.nome_responsavel = 'Informe o nome do responsável';
    } else if (formData.nome_responsavel.length < 3) {
      newErrors.nome_responsavel = 'Use ao menos 3 caracteres';
    }

    if (!formData.email_responsavel) {
      newErrors.email_responsavel = 'O e-mail é obrigatório';
    } else if (!validateEmail(formData.email_responsavel)) {
      newErrors.email_responsavel = 'Digite um e-mail válido';
    }

    if (!formData.celular_zap_responsavel) {
      newErrors.celular_zap_responsavel = 'O celular é obrigatório';
    } else if (!validatePhone(formData.celular_zap_responsavel)) {
      newErrors.celular_zap_responsavel = 'Digite no formato (XX)XXXXX-XXXX';
    }

    if (!formData.cargo_responsavel) {
      newErrors.cargo_responsavel = 'Informe o cargo do responsável';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    nextStep();
  };

  return (
    <FormContainer>
      <Title>Vamos começar pelos seus dados</Title>
      <Description>
        Precisamos do nome, e-mail, cargo e celular de quem está preenchendo o formulário. Essas informações
        serão usadas para manter o contato sobre a filiação.
      </Description>
      <form onSubmit={handleSubmit}>
        <FormField
          label="Nome do Responsável"
          name="nome_responsavel"
          placeholder="Digite o nome completo"
          value={formData.nome_responsavel}
          onChange={handleChange}
          error={errors.nome_responsavel}
        />

        <FormField
          label="Seu email"
          name="email_responsavel"
          type="email"
          placeholder="Digite seu e-mail"
          value={formData.email_responsavel}
          onChange={handleChange}
          error={errors.email_responsavel}
        />

        <FormField
          label="Celular/WhatsApp"
          name="celular_zap_responsavel"
          placeholder="Informe o telefone com DDD"
          value={formData.celular_zap_responsavel}
          onChange={handleChange}
          error={errors.celular_zap_responsavel}
          mask="(99)99999-9999"
        />

        <FormField
          label="Cargo do responsável"
          name="cargo_responsavel"
          placeholder="Ex: Diretor executivo"
          value={formData.cargo_responsavel}
          onChange={handleChange}
          error={errors.cargo_responsavel}
        />
        <Button type="submit" primary fullWidth>
          Começar
        </Button>
      </form>
    </FormContainer>
  );
};

export default WelcomeScreen;

